import { apiFetch } from './client';

export type BackupProvider = 'r2' | 's3';
export type BackupScope = 'customer' | 'reseller';

export interface BackupConfigView {
  id: string;
  scope: BackupScope;
  reseller_id: string;
  customer_id: string | null;
  enabled: boolean;
  provider: BackupProvider;
  account_id: string | null;
  endpoint: string;
  region: string;
  bucket: string;
  prefix: string | null;
  last_sync_at: string | null;
  last_sync_status: string | null;
  last_sync_error: string | null;
  synced_bytes: number;
  synced_object_count: number;
  access_key_id_redacted: string;
  created_at: string;
  updated_at: string;
}

export interface BackupConfigBody {
  enabled: boolean;
  provider: BackupProvider;
  account_id?: string | null;
  access_key_id: string;
  secret_access_key: string;
  endpoint: string;
  region: string;
  bucket: string;
  prefix?: string | null;
}

export interface BackupVerifyResult {
  ok: boolean;
  error?: string;
  provider?: string;
  bucket?: string;
}

export const backupConfigs = {
  getForCustomer: (id: string) =>
    apiFetch<{ config: BackupConfigView | null }>(`/api/customers/${id}/backup-config`),
  putForCustomer: (id: string, body: BackupConfigBody) =>
    apiFetch<{ config: BackupConfigView }>(`/api/customers/${id}/backup-config`, {
      method: 'PUT', body: JSON.stringify(body),
    }),
  removeForCustomer: (id: string) =>
    apiFetch<void>(`/api/customers/${id}/backup-config`, { method: 'DELETE' }),

  getForReseller: (id: string) =>
    apiFetch<{ config: BackupConfigView | null }>(`/api/resellers/${id}/backup-config`),
  putForReseller: (id: string, body: BackupConfigBody) =>
    apiFetch<{ config: BackupConfigView }>(`/api/resellers/${id}/backup-config`, {
      method: 'PUT', body: JSON.stringify(body),
    }),
  removeForReseller: (id: string) =>
    apiFetch<void>(`/api/resellers/${id}/backup-config`, { method: 'DELETE' }),

  verify: (configId: string) =>
    apiFetch<BackupVerifyResult>(`/api/backup-configs/${configId}/verify`, { method: 'POST' }),
};
